import Vue from 'vue'
import {hasMenu} from './prowers'

const hasPowers = function (el, value) {
    if (!hasMenu(value)) {
        el.style.display = 'none'
    } else {
        el.style.display = ''
    }
}

// 模块权限校验指令
Vue.directive('powers-2', {
    inserted: function (el, {value, oldValue}) {
        hasPowers(el, value)
    },
    update: function (el, {value, oldValue}) {
        if (value !== oldValue) {
            hasPowers(el, value)
        }
    }
})



// WEBPACK FOOTER //
// ./src/util/v-directive.js